import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { Card, Stack, StackItem, Typography } from '@optimus-web/core';
import { LocalizedCurrencyValue } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { GeneralPricingMode } from '@mews-commander/data-access';
import { LocalizedMinorHighlight, LocalizedParagraph, LocalizedSmallParagraph } from '@mews-commander/ui';

interface Props {
    count: number;
    currency: string;
    hasSingleCurrency: boolean;
    totalAmount: number;
    hasProducts: boolean;
}

export const TotalBar = ({ count, currency, hasSingleCurrency, totalAmount, hasProducts }: Props) => {
    const pricingMode = useCurrentEnterprise().pricing;

    return (
        <Card variant="highlighted" padding="200" outline={false} cornerRadius="small">
            <Stack distribution="space-between" itemAlignment="center">
                <StackItem>
                    {hasProducts && (
                        <LocalizedMinorHighlight
                            textKey={TextKey.AddServiceToReservationTotalProductsCount}
                            substitutes={{ count }}
                        />
                    )}
                </StackItem>

                <Stack vertical itemAlignment="end">
                    <Stack spacing="50" wrap>
                        <LocalizedMinorHighlight textKey={TextKey.Total} />

                        {pricingMode === GeneralPricingMode.Gross && (
                            <LocalizedParagraph textKey={TextKey.AddServiceToReservationTotalInclTaxes} />
                        )}

                        <Typography textStyle="bodyLargeStrong" as="div">
                            <LocalizedCurrencyValue
                                value={{
                                    value: totalAmount,
                                    currency,
                                }}
                            />
                        </Typography>
                    </Stack>
                    {!hasSingleCurrency && (
                        <LocalizedSmallParagraph
                            variant="secondary"
                            textKey={TextKey.AddServiceToReservationTotalCurrencyHelper}
                        />
                    )}
                </Stack>
            </Stack>
        </Card>
    );
};
